// src/pages/subscription/SubscriptionCancel.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import SubscriptionPlans from '../../components/subscription/SubscriptionPlans';

const SubscriptionCancel: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-lg">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          
          {/* Cancel Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
            </div>
          </div>

          {/* Content */}
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Subscription Canceled
            </h1>
            
            <p className="text-gray-600 mb-6">
              You canceled the upgrade process. No charges were made to your account.
            </p>

            {/* Reminder of Pro Benefits */}
            <div className="bg-sky-50 rounded-lg p-4 mb-6 text-left">
              <h3 className="font-semibold text-sky-900 mb-2">You missed out on:</h3>
              <ul className="text-sky-800 text-sm space-y-1">
                <li>• Unlimited smart task planning</li>
                <li>• Advanced day summaries and insights</li>
                <li>• Smart capture-to-task conversion</li>
                <li>• Priority email support</li>
              </ul>
            </div>

            {/* Try Again Section */}
            <div className="mb-6">
              <p className="text-gray-600 text-sm mb-4">
                Still interested? You can upgrade anytime from your profile settings.
              </p>
              
              <div className="space-y-3">
                <Link 
                  to="/profile/subscription"
                  className="w-full inline-flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  Try Upgrading Again
                </Link>
                
                <Link 
                  to="/today"
                  className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  Continue with Free Plan
                </Link>
              </div>
            </div>

            {/* Feedback */}
            <div className="pt-4 border-t border-gray-200">
              <p className="text-sm text-gray-500 mb-2">
                Why did you cancel? Help us improve:
              </p>
              <div className="flex flex-wrap gap-2 justify-center">
                <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-full text-xs text-gray-600 transition-colors">
                  Too expensive
                </button>
                <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-full text-xs text-gray-600 transition-colors">
                  Need more features
                </button>
                <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-full text-xs text-gray-600 transition-colors">
                  Not ready yet
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Support Info */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Questions about Pro features? Contact us at{' '}
            <a 
              href="mailto:support@orlo.cc" 
              className="text-sky-600 hover:text-sky-500"
            >
              support@orlo.cc
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;